import { checkGameType, providerTypes } from "BaseServiceURLs";
import { SiteFeatures } from "config/siteFeatures";
import {
  parseProviderKey,
  createPermissionKey as createSlotsPermissionKey,
} from "./Casino/FilterSearch";
import { createPermissionKey as createLiveCasinoPermissionKey } from "./LiveCasino/FilterSearch";

// checkGameType/providerTypes zaten launch sırasında returnUrl oluşturmak için
// kullanılıyor (bkz. BaseServiceURLs.getReturnUrl) - burada da AYNI sınıflandırmayı
// kullanıyoruz ki listeleme ile launch arasında sınıflandırma sapması olmasın.
const CATEGORY_BY_TYPE_ID = {
  [providerTypes[0]._id]: "slots",
  [providerTypes[1]._id]: "live",
  [providerTypes[2]._id]: "tvgames",
  [providerTypes[3]._id]: "virtual",
  [providerTypes[4]._id]: "sports",
  [providerTypes[5]._id]: "games",
};

export const resolveGameCategory = (gameData) => {
  const typeId = checkGameType(gameData);
  return CATEGORY_BY_TYPE_ID[typeId] || "slots";
};

// SettingName formatı gerçek asset JSON'larından (games.json/virtual.json/tvgames.json)
// doğrulandı: sadece INNOVA_ önekiyle örnekler var (ör. "INNOVA_MICRO-GAMING_GAMES_ACCESS"),
// dash korunuyor. Games/index.jsx'te ayrıca gasea (mini/fish) için de aynı süfiksle bir
// kontrol zaten deneniyordu (middleware prefiksiz, Casino/FilterSearch'teki gasea istisnasıyla
// aynı desende); bu yüzden gasea burada da destekleniyor. Virtual/TVGames kaynak kodunda gasea
// hiç kullanılmıyor, o yüzden oralarda sadece innova modelleniyor.
export const createGamesPermissionKey = (providerValue, middleware) => {
  let permissionKey = providerValue
    .toUpperCase()
    .replace(/\s/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

  let middlewareKey = middleware
    .toUpperCase()
    .replace(/-/g, "_")
    .replace(/\s/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

  if (middleware === "gasea") {
    return `${permissionKey}_GAMES_ACCESS`;
  }
  return `${middlewareKey}_${permissionKey}_GAMES_ACCESS`;
};

export const createVirtualPermissionKey = (providerValue, middleware) => {
  let permissionKey = providerValue
    .toUpperCase()
    .replace(/\s/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

  let middlewareKey = middleware
    .toUpperCase()
    .replace(/-/g, "_")
    .replace(/\s/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

  return `${middlewareKey}_${permissionKey}_VIRTUAL_ACCESS`;
};

export const createTvGamesPermissionKey = (providerValue, middleware) => {
  let permissionKey = providerValue
    .toUpperCase()
    .replace(/\s/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

  let middlewareKey = middleware
    .toUpperCase()
    .replace(/-/g, "_")
    .replace(/\s/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

  return `${middlewareKey}_${permissionKey}_TVGAMES_ACCESS`;
};

// Bu projede games.json/virtual.json/tvgames.json içinde sadece INNOVA_ önekli
// SettingName kanıtı var (Games bölümünde ayrıca gasea/mini-fish kanıtı da var,
// bkz. Games/index.jsx). matgame/nonameHero/blas975 için bu kategorilerde hiçbir
// SettingName kanıtı yok - bu middleware'lerin games/virtual/tvgames kategorisine
// düşen oyunları (ör. matgame: spaceman/aviatrix/jetx/goldenrace) sadece bölüm
// seviyesindeki route izniyle (GAMES_ACCESS/VIRTUAL_ACCESS/TVGAMES_ACCESS) korunuyor;
// kanıtsız bir provider-bazlı kural eklemek onları haksız yere gizler.
const hasEvidencedPermissionConvention = (category, middleware) => {
  if (category === "games") return middleware === "innova" || middleware === "gasea";
  if (category === "virtual" || category === "tvgames") return middleware === "innova";
  return true;
};

// Casino/LiveCasino listeleme sayfalarındaki isProviderKeyAllowed ile AYNI mantığı,
// tekil bir oyun + middleware için uygular. Hem launcher route guard'larında (Bölüm B)
// hem de Games/Virtual/TVGames listeleme filtrelerinde kullanılır ki liste ile launch
// birbirinden sapmasın.
export const isGameLaunchAllowed = (gameData, providerId, middleware, permissions, loggedIn) => {
  if (!gameData || !middleware) return false;

  const category = resolveGameCategory(gameData);
  const isGuestPreview = !SiteFeatures.CLOSED_SYSTEM && !loggedIn;

  if (!hasEvidencedPermissionConvention(category, middleware)) {
    return true;
  }

  const originalProviderName = parseProviderKey(providerId || "").originalName || providerId || "";

  switch (category) {
    case "slots": {
      const key = createSlotsPermissionKey(originalProviderName, middleware);
      return isGuestPreview || !!permissions?.[key]?.Value;
    }
    case "live": {
      const key = createLiveCasinoPermissionKey(originalProviderName, middleware);
      return isGuestPreview || !!permissions?.[key]?.Value;
    }
    case "games": {
      const key = createGamesPermissionKey(gameData.vendor || originalProviderName, middleware);
      return isGuestPreview || !!permissions?.[key]?.Value;
    }
    case "virtual": {
      const key = createVirtualPermissionKey(gameData.vendor || originalProviderName, middleware);
      return isGuestPreview || !!permissions?.[key]?.Value;
    }
    case "tvgames": {
      const key = createTvGamesPermissionKey(gameData.vendor || originalProviderName, middleware);
      return isGuestPreview || !!permissions?.[key]?.Value;
    }
    default:
      return true;
  }
};
